type ColumnHeaderInfoBtnText = {
    ariaLabel?: string;
}

export interface ResourceTableInfoButtonProps {
    text: ColumnHeaderInfoBtnText
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    onKeyDown?: (event: React.KeyboardEvent<HTMLButtonElement>) => void;
}

export const ColumnHeaderInfoButton = (
    {text, onClick, onKeyDown}: ResourceTableInfoButtonProps
): JSX.Element => {
    return(
        <button
            className="resourceTableHeaderIconBtn"
            onClick={onClick}
            tabIndex={0}
            aria-label={text.ariaLabel}
            onKeyDown={onKeyDown}
        >
            <i
                className="fa-solid fa-info-circle resourceTableHeaderIcon"
                aria-hidden="true"
            />
        </button>
    );
};